<template>
  <div class='content'>
    <div class="body" :loading="listLoading">
      <div class="search-box ban">
        <div class="input-item">
          <span class="label">保险产品</span>
          <Select v-model="searchParams.productId" clearable filterable>
            <Option v-for="(item, index) in productList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="btn-item8">
          <Button type="primary" icon="ios-search" @click="searchAjax(false)">查询</Button>
        </div>
      </div>
      <div class="toolbox clearfix">
        <div class="add-btn">
          <Button type="warning" ghost icon="ios-cloud-download-outline" @click="handleDownload">一键下载</Button>
        </div>
      </div>
      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table ref="selection" :columns="columns" :data="tableData" @on-selection-change="onSelectChange" @on-row-click="onSelectRow">
          <template slot-scope="{ row, index }" slot="file" v-if="row.file">
            <p style="cursor: pointer; color: #236DFF" v-for="(item, index) in JSON.parse(row.file || '[]')" :key="index" @click="toUrl(item.path)">{{ item.fileName }}</p>
          </template>
          <template slot-scope="{ row, index }" slot="pic" v-if="row.pic">
            <img v-for="(v, i) in JSON.parse(row.pic || '[]')" :src="v.path" :preview="row.id" :key="i" style="width: 100px;height: 100px" />
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page
          :total="total"
          :current="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>

  </div>
</template>
<script>
import { pageTool, common } from "@/api/mixins";
let vm;
export default {
  mixins:[pageTool, common],
  components: { },
  data:()=>({
    columns:[
      {
        title: "序号",
        type: 'selection',
        width: 60,
        align: 'center'
      },
      {
        title: "标题",
        key:"title",
        minWidth: 100,
        align: 'center'
      },
      {
        title: "保险产品",
        key:"productName",
        minWidth: 100,
        align: 'center',
      },
      {
        title: "PDF",
        key:"file",
        minWidth: 100,
        align: "center",
        slot: "file"
      },
      {
        title: "图片",
        slot:"pic",
        minWidth: 200,
        align: 'center',
      },
    ],
    selectArr: [],
    productList: []
  }),
  mounted() {
    vm = this;
  },
  created() {
    vm = this;
    this.queryProductList();
    this.initListAjax("/buz/otherInformation/read/list");
  },
  methods:{
    // 查询所有产品
    queryProductList() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.productList = res.data;
      });
    },
    setListParams(params){
      params.type = '2';
    },

    // 选中
    onSelectChange(selectArr) {
      vm.selectArr = selectArr;
    },
    //单击行
    onSelectRow(data, index) {
      vm.$refs.selection.selectAll(false);
      vm.$refs.selection.toggleSelect(index)  // 重点 选中勾选
    },

    // 页面切换
    pageChange(index){
      vm.pageNum = index
      vm.getList()
    },
    toUrl(url){
      window.open(url)
    },
    handleDownload() {
      if (vm.selectArr.length == 0 && (Object.keys(this.searchParams).length == 0 || Object.values(this.searchParams).every(v => v === undefined))) {
        vm.$notice.msg('请选择一项');
        return;
      }
      if (vm.selectArr.length > 1) {
        vm.$notice.msg('只能选择一项');
        return;
      }
      vm.$units.downloadFile('/buz/otherInformation/information/down', { id: vm.selectArr[0]?.id, ...this.searchParams }, 'POST');
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  min-width: 1080px;
  min-height: calc(100vh);
  background: #fff;
  .body {
    background: #fff;
    padding: 25px;
    .search-box {
      margin-bottom: 10px;
      .input-item1 {
        width: 33.3%;
        display: inline-block;
        position: relative;
        .label {
          width: 117px;
          position: absolute;
          left: 0;
          top: 0;
          margin: auto;
          line-height: 32px;
          text-align: right;
        }
        .ivu-input-wrapper {
          display: inline-block;
          margin-left: 127px;
          width: calc(100% - 137px);
        }
      }
    }
    .toolbox {
      line-height: 46px;
      background-color: #f8f8f9;
      border-top: 1px solid #e8eaec;
      border-left: 1px solid #e8eaec;
      border-right: 1px solid #e8eaec;
      .add-btn {
        float: right;
        margin-right: 10px;
      }
    }
    .tableBox {
      padding-bottom: 25px;
      background-color: #fff;
      position: relative;
      z-index: 100;
      .bjbtn {
        color: #236dff;
        font-size: 14px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .table-top {
      margin-top: 30px;
    }
  }
}
/deep/ .insuranceModal {
  letter-spacing: 1px;
}
/deep/ .ivu-modal-body {
  padding: 40px 30px 10px 30px;
  .descitem {
    .ivu-form-item-label {
      width: 114px !important;
    }
  }
}
</style>